import { createIcon } from "@chakra-ui/icons"

const CircleMinusRegular = createIcon({
  displayName: "CircleMinusRegular",
  viewBox: "0 0 512 512",
  path: (
    <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z" />
  ),
})

export default CircleMinusRegular
